/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500,
} from "../../types/pecegePayCreditCardController/PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay.ts";

function getPatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayUrl(
  courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams["courseFinPersonPaymentId"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/pecegepay/creditcard/${courseFinPersonPaymentId}/pay` as const,
  };
  return res;
}

/**
 * @description Efetua o pagamento de uma parcela com cartão de crédito.
 * @summary Pagar parcela
 * {@link /api/v1/pecegepay/creditcard/:courseFinPersonPaymentId/pay}
 */
export async function patchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay(
  courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayPathParams["courseFinPersonPaymentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay401
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPay500
    >,
    unknown
  >({
    method: "PATCH",
    url: getPatchApiV1PecegepayCreditcardCoursefinpersonpaymentidPayUrl(
      courseFinPersonPaymentId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
